const formErrors = (value: any, extra: boolean = true) => {
  if (value && extra) {
    return { help: value, validateStatus: 'error' };
  }
  return {} as any;
};

export default formErrors;
